import React from "react";
import { withTheme } from "styled-components";
import PropTypes from "prop-types";
import {
  LoaderContainer,
  LoaderLayer,
  Loader,
  Text
} from "./InlineLoaderStyled";
import { useTranslate } from "hooks/translation-hooks";

export const InlineLoader = ({ isLoading }) => {
  const t = useTranslate();
  return (
    <LoaderLayer isLoading={isLoading}>
      <LoaderContainer>
        <Loader data-testid="upload_photo-loader" isLoading={isLoading} />
        <Text data-testid="upload_photo-text_loader" isLoading={isLoading}>
          {t("uploading_photo-spinner")}
        </Text>
      </LoaderContainer>
    </LoaderLayer>
  );
};

InlineLoader.propTypes = {
  isLoading: PropTypes.bool,
  theme: PropTypes.shape({}).isRequired
};

InlineLoader.defaultProps = {
  isLoading: false
};

export default withTheme(InlineLoader);
